module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource-w720.04de5604.webp";